import React from "react";
import PaginatedTable from '../components/paginatedTable'

import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import NewTeamUserDialog from "../components/newTeamUserDialog";
import NewPriceDialog from "../components/newPriceDialog";

const items = [
  { id: 1, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'jon.jones@gmail.com' },
  { id: 2, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'cersei.jones@gmail.com' },
  { id: 3, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'jaime.jones@gmail.com' },
  { id: 4, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'arya.jones@gmail.com' },
  { id: 5, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'daenerys.jones@gmail.com' },
  { id: 6, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'camille.jones@gmail.com' },
  { id: 7, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'ferrara.jones@gmail.com' },
  { id: 8, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'rossini.jones@gmail.com' },
  { id: 9, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'harvey.jones@gmail.com' },
  { id: 10, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'jon.jones@gmail.com' },
  { id: 11, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'cersei.jones@gmail.com' },
  { id: 12, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'jaime.jones@gmail.com' },
  { id: 13, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'arya.jones@gmail.com' },
  { id: 14, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'daenerys.jones@gmail.com' },
  { id: 15, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'camille.jones@gmail.com' },
  { id: 16, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'ferrara.jones@gmail.com' },
  { id: 17, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'rossini.jones@gmail.com' },
  { id: 18, priceName: 'Standard', value: 140, currency: 140, plans: 1, email: 'harvey.jones@gmail.com' },
];

export default function Prices() {
  const [rows, setRows] = React.useState(items);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const header = [
    { field: 'priceName', headerName: 'Price Name', width: 130 },
    { field: 'value', headerName: 'Value', type: "number", width: 130 },
    { field: 'currency', headerName: 'Currency', type: "number", width: 130 },
    { field: 'plans', headerName: 'Plans', type: "number", width: 130 },
    { field: 'email', headerName: 'Contact Email', width: 200 },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
  
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: 'primary.main',
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }
  
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    }
  ];

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (!!editedRow && editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  return (
    <div className="p-5 flex justify-center items-center h-full max-h-[100vh]">
      <div className="p-5 flex items-center justify-center w-full h-full max-h-full bg-[#191919] rounded-2xl">
        <div className="flex flex-col gap-5 max-w-full max-h-full w-full h-full relative">
          
          <div className="flex justify-between items-center w-full">
            <h1 className="text-6xl font-medium">Prices</h1>
            <NewPriceDialog />
          </div>
          <PaginatedTable header={header} items={items} />
        </div>
      </div>
    </div>
  )
}